import { PROPERTY_GET_ENDPOINT } from "../Constants/api-routes.constant";
import { GetAuthToken } from "./auth-verification.util";


export const GetPropertyDetailsByID = (propertyId) => {
    if(!propertyId) return null;
    const token = GetAuthToken();
      if (!token) return [];
    
      return fetch(`${PROPERTY_GET_ENDPOINT}/${propertyId}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          return response.json();
        })
        .catch((err) => {
          return err;
        });
}